<div class="modal-content kml-upload-modal" data-backdrop="static" *ngIf="!close">
  <div class="modal-header upload-header">
    <h3 class="modal-title">Upload</h3>
  </div>
  <div class="modal-body">
    <p [innerHTML]="annotation_upload | sanitizeHtml">
    </p>
    <div class="row">
      <div class="col-xs-3">
        <div class="upload-btn-wrapper">
          <button class="btn choose-btn">Choose file</button>
          <input
            class="input-file mb-0"
            type="file"
            name="myfile"
            accept=".kml, .kmz"
            (change)="onKmlUploadChange($event)"
          />
        </div>
        <!-- <div class="input-file-outer">
                    <div class="btn choose-btn btn-z-index" (click)="on_kml_choose_btn()">Choose file</div>
                    <input class="input-file" type="file" accept=".kml, .kmz" (change)="on_kml_upload_change($event)">
                </div> -->
      </div>
      <div class="col-xs-9">
        <input
          type="text"
          class="upload-file-name"
          readonly=""
          [(ngModel)]="filename"
        />
      </div>
    </div>
    <div class="upload-error-body" *ngIf="error">
      <div class="error-text" [innerHTML]="errorMessage"></div>
      <p class="error-file-name">{{ errorFileName }}</p>
      <br class="br-clear" clear="all" />
    </div>
  </div>

  <div class="modal-footer upload-footer">
    <div class="footer-border"></div>
    <button
      type="reset"
      class="btn btn-default upload-close-btn pull-left"
      data-dismiss="modal"
      (click)="onKmlClose()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn choose-btn pull-right"
      id="upload-kml-btn"
      [disabled]="!filename"
      (click)="onKmlUpload()"
    >
      Upload
    </button>
  </div>
</div>
